<template>
    <svg class="icon" :class='["icon-"+ this.name]' width="100" height="100" viewbox="0 0 32 32">
        <use :href="iconName"></use>
    </svg>
</template>
<script>
//import Icons from '../assets/icons.svg';
export default {
    props: {
        "name": String, 
        "width": Number,
        "height": Number, 
    },
    computed: {
		iconName () {
            return "#icon-" + this.name;
        }
    }
}
</script>
<style scoped>
    svg {
        height: 1rem;
        width: auto;
        display: inline-block;
    }
</style>